const termsES = {
	title: "Términos y Condiciones",
	lastUpdated: "Fecha de Vigencia",
	close: "Cerrar",

	intro: {
		heading: "1) Introducción y Acuerdo",
		p1: "Sin Fila (“nosotros”, “nuestro” o “nos”) proporciona una plataforma en línea que permite a los clientes reservar citas en barberías y salones de belleza, y ayuda a los profesionales a gestionar horarios y comunicaciones (“Servicios”).",
		p2: "Al acceder o utilizar nuestro sitio web, aplicación o servicios relacionados, usted acepta estar sujeto a estos Términos y Condiciones (“Términos”) y a nuestra Política de Privacidad. Si no está de acuerdo, no utilice los Servicios.",
		p3: "Importante: Sin Fila es únicamente una plataforma. No somos el proveedor de los servicios, y no garantizamos la calidad, seguridad, legalidad o disponibilidad de ningún servicio.",
	},

	eligibility: {
		heading: "2) Elegibilidad y Uso del Servicio",
		list: [
			"Los usuarios deben tener la capacidad legal para celebrar contratos en su jurisdicción.",
			"Si usted es menor de edad según su jurisdicción, solo puede usar los Servicios con el consentimiento de un padre o tutor legal, quien acepta estos Términos en su nombre.",
			"Usted acepta utilizar los Servicios únicamente con fines legales y de acuerdo con estos Términos.",
			"Podemos modificar, suspender o descontinuar cualquier parte de los Servicios en cualquier momento.",
		],
	},

	accounts: {
		heading: "3) Cuentas y Seguridad",
		list: [
			"Usted es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades realizadas en su cuenta.",
			"Acepta proporcionar información precisa, actual y completa, y mantenerla actualizada.",
			"Notifique inmediatamente cualquier uso no autorizado o vulneración de seguridad.",
		],
	},

	bookings: {
		heading: "4) Reservas, Cancelaciones y Pagos",
		p1: "Los Servicios facilitan reservas entre clientes y barberos/salones independientes. Todos los pagos por servicios se realizan directamente entre clientes y barberos/salones. Sin Fila no procesa ni maneja pagos de usuarios.",
		p2: "Los negocios pagan a Sin Fila tarifas por usar la plataforma (suscripción, servicio o tarifas basadas en transacción).",
		p3: "Cada negocio puede establecer sus propias políticas de precios, depósitos, cancelaciones y no-shows. Usted acepta revisar y cumplir con las políticas mostradas al momento de la reserva.",
		p4: "Podemos asistir en disputas, pero no garantizamos resultados.",
		p5: "Sin Fila no garantiza operación sin errores y no es responsable por reservas fallidas o retrasadas debido a problemas técnicos.",
	},

	proResponsibilities: {
		heading: "5) Responsabilidades Profesionales / de Negocio",
		list: [
			"Los barberos/salones son independientes y responsables exclusivamente de cumplir con leyes aplicables, licencias, impuestos y normas de seguridad.",
			"Los negocios deben garantizar que disponibilidad, precios, servicios y políticas mostradas en la plataforma sean precisos y estén actualizados.",
			"Los negocios son responsables de la conducta de su personal y de entregar los servicios reservados.",
			"Los negocios no pueden ofrecer ni listar servicios ilegales o ilícitos.",
		],
	},

	acceptableUse: {
		heading: "6) Uso Aceptable / Conducta Prohibida",
		list: [
			"Realizar actividades ilegales, dañinas, fraudulentas o engañosas.",
			"Interferir con la operación de los Servicios o intentar acceder a áreas no autorizadas.",
			"Copiar, extraer o descompilar los Servicios salvo lo permitido por la ley.",
			"Publicar contenido ilegal, ofensivo, difamatorio, spam o que infrinja derechos de terceros.",
		],
	},

	userContent: {
		heading: "7) Contenido del Usuario",
		p1: "Los usuarios conservan la propiedad del contenido que envían (reseñas, comentarios, retroalimentación), pero otorgan a Sin Fila una licencia mundial, libre de regalías y no exclusiva para alojar, mostrar y distribuir el contenido con el fin de operar los Servicios.",
		p2: "El contenido debe cumplir con la Sección 6 anterior.",
	},

	ip: {
		heading: "8) Propiedad Intelectual",
		p1: "Los Servicios, incluyendo software, textos, gráficos, logotipos y demás contenidos, son propiedad de o están licenciados a Sin Fila y están protegidos por leyes de propiedad intelectual.",
		p2: "Salvo lo expresamente permitido, no se otorgan derechos para copiar, reproducir o usar nuestra propiedad intelectual.",
	},

	disclaimer: {
		heading: "9) Exención de Garantías",
		p1: "LOS SERVICIOS SE PROPORCIONAN “TAL CUAL” Y “SEGÚN DISPONIBILIDAD”, SIN GARANTÍAS DE NINGÚN TIPO, EXPRESAS O IMPLÍCITAS, INCLUYENDO COMERCIABILIDAD, ADECUACIÓN PARA UN FIN PARTICULAR O NO INFRACCIÓN.",
		p2: "Nos esforzamos por mantener los Servicios disponibles, pero no garantizamos acceso ininterrumpido o libre de errores. Pueden ocurrir interrupciones temporales debido a mantenimiento, actualizaciones, problemas técnicos o eventos fuera de nuestro control.",
	},

	liability: {
		heading: "10) Limitación de Responsabilidad",
		p1: "HASTA EL MÁXIMO PERMITIDO POR LA LEY, EN NINGÚN CASO SIN FILA O SUS AFILIADOS SERÁN RESPONSABLES POR DAÑOS INDIRECTOS, INCIDENTALES, ESPECIALES, CONSECUENCIALES, EJEMPLARES O PUNITIVOS.",
		p2: "Nuestra responsabilidad total por cualquier reclamo relacionado con los Servicios no excederá el mayor de: El monto pagado por el negocio a nosotros en los 3 meses anteriores al reclamo.",
		p3: "Los usuarios aceptan que las disputas con negocios son entre el usuario y el negocio, no con Sin Fila.",
	},

	indemnity: {
		heading: "11) Indemnización",
		text: "Usted se compromete a indemnizar y mantener indemne a Sin Fila de cualquier reclamo, daño, responsabilidad o gasto que surja de su uso de los Servicios, violación de estos Términos o incumplimiento de la ley aplicable.",
	},

	termination: {
		heading: "12) Terminación y Suspensión",
		text: "Podemos suspender o terminar el acceso a los Servicios en cualquier momento, con o sin aviso, por violación de estos Términos o uso indebido. La terminación no afecta derechos acumulados, tarifas o obligaciones de indemnización.",
	},

	privacy: {
		heading: "13) Privacidad",
		text: "Al usar los Servicios, usted consiente la recolección, uso y tratamiento de sus datos como se describe en nuestra Política de Privacidad.",
	},

	law: {
		heading: "14) Ley Aplicable y Disputas",
		text: "Estos Términos se rigen por las leyes de la República Dominicana.",
	},

	changes: {
		heading: "15) Cambios a los Términos",
		text: "Podemos actualizar estos Términos en cualquier momento. El uso continuo de los Servicios después de que los cambios entren en vigor constituye aceptación de los Términos actualizados.",
	},

	misc: {
		heading: "16) Miscelánea",
		list: [
			"Acuerdo Completo: Estos Términos constituyen el acuerdo completo entre usted y nosotros.",
			"Divisibilidad: Si alguna disposición es inválida, las demás permanecen en efecto.",
			"No Renuncia: La falta de aplicación de una disposición no renuncia al derecho de aplicarla en el futuro.",
			"Cesión: No puede transferir derechos u obligaciones sin nuestro consentimiento.",
		],
	},
};

export default termsES;
